import styled from "styled-components";
import { SIDEBAR_W, TOPBAR_H } from "../../config/layout";


export const Layout = styled.div`
  display: flex;
  min-height: 100vh;
  padding-top: ${TOPBAR_H};
  background: #e8f2f7;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
`;

export const Main = styled.main`
  margin-left: ${SIDEBAR_W};
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 14px 32px;
  background: #fff;
  border-bottom: 1px solid #e0e8f0;
`;

export const AddButton = styled.button`
  padding: 8px 20px;
  border-radius: 20px;
  border: 1.5px solid #26A9B6;
  background: #fff;
  color: #26A9B6;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;

  &:hover { background: #f0fbfc; }
`;

/* Márgenes del diseño: 76px a la izquierda de la barra lateral y 332px a la
   derecha. En pantallas más estrechas el margen derecho se iguala al izquierdo,
   para no dejar las dos columnas de tarjetas demasiado apretadas. */
export const Content = styled.div`
  padding: 28px 332px 28px 76px;
  display: flex;
  flex-direction: column;
  /* Separación entre el título y el panel de actividades */
  gap: 36px;

  @media (max-width: 1500px) { padding-right: 76px; }
  @media (max-width: 900px)  { padding: 28px 24px; }
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
`;

export const PageTitle = styled.h1`
  margin: 0;
  font-size: 1.6rem;
  font-weight: 700;
  color: #1b3a6b;
  white-space: nowrap;
`;

/* Los filtros de tipo van sobre una píldora blanca, como en el diseño */
export const TabsRow = styled.div`
  display: inline-flex;
  gap: 4px;
  flex-wrap: wrap;
  background: #fff;
  border-radius: 999px;
  padding: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
`;

export const Tab = styled.button`
  padding: 6px 18px;
  border-radius: 20px;
  border: none;
  background: ${({ $active }) => ($active ? "#1b3a6b" : "transparent")};
  color: ${({ $active }) => ($active ? "#fff" : "#666")};
  font-size: 0.85rem;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  cursor: pointer;
  transition: background 0.15s, color 0.15s;

  &:hover {
    background: ${({ $active }) => ($active ? "#1b3a6b" : "#dce8f0")};
    color: ${({ $active }) => ($active ? "#fff" : "#1b3a6b")};
  }
`;

export const ActivityPanel = styled.div`
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.07);
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 14px;
`;

// El PNG ya trae su propio fondo, asi que no lleva envoltorio de color.
export const TypeIconWrap = styled.img`
  width: 42px;
  height: 42px;
  flex-shrink: 0;
`;

export const TypeInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const TypeName = styled.h2`
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: #1b3a6b;
`;

export const TypeSubtitle = styled.p`
  margin: 0;
  font-size: 0.82rem;
  color: #888;
`;

export const SelectedCounter = styled.span`
  font-size: 0.78rem;
  font-weight: 700;
  color: #999;
  white-space: nowrap;
  letter-spacing: 0.04em;
`;

export const ActivitiesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
`;

export const ActivityCard = styled.div`
  border: 2px solid ${({ $selected }) => ($selected ? "#1b6b78" : "transparent")};
  border-radius: 10px;
  padding: 14px 16px;
  background: ${({ $selected }) => ($selected ? "#fff" : "#f5f7f8")};
  display: flex;
  flex-direction: column;
  gap: 8px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;

  &:hover {
    border-color: #26A9B6;
  }
`;

export const CardTop = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

// Es el unico control que prescribe (el resto de la tarjeta abre la ficha), asi
// que necesita cursor y foco propios.
export const Checkbox = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 2px solid ${({ $checked }) => ($checked ? "#1b6b78" : "#ccd6de")};
  background: ${({ $checked }) => ($checked ? "#1b6b78" : "#fff")};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
  transition: all 0.15s;

  &:hover { border-color: #1b6b78; }
  &:focus-visible { outline: 2px solid #26A9B6; outline-offset: 2px; }
`;

export const CardName = styled.h3`
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  color: #1b3a6b;
  flex: 1;
`;

export const SeenBadge = styled.span`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.8rem;
  color: #8fa3b0;
  flex-shrink: 0;

  img { width: 18px; height: 18px; }
`;

export const EditIconBtn = styled.button`
  background: none;
  border: none;
  padding: 0;
  width: 20px;
  height: 20px;
  cursor: pointer;
  color: #aab4be;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &:hover { color: #26A9B6; }
`;

export const GoalLabel = styled.p`
  margin: 4px 0 0;
  font-size: 0.85rem;
  font-weight: 700;
  color: #1b2b3a;
`;

export const GoalText = styled.p`
  margin: 0;
  font-size: 0.85rem;
  color: #55636e;
  line-height: 1.5;
  /* El objetivo puede venir numerado en varias lineas desde el Excel, y el
     texto de la BD trae saltos \r\n. */
  white-space: pre-line;
`;

/* ── Filtros ── */
export const FilterRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;
  flex-wrap: wrap;
`;

export const FilterLabel = styled.span`
  font-size: 0.85rem;
  font-weight: 600;
  color: #1b2b3a;
  padding-bottom: 9px;
  flex-shrink: 0;
`;

export const FilterField = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  min-width: 180px;
`;

export const FilterFieldLabel = styled.span`
  font-size: 0.82rem;
  color: #55636e;
`;

export const FilterSelect = styled.select`
  padding: 9px 12px;
  border-radius: 6px;
  border: 1px solid #dfe6ec;
  background: #fff;
  font-size: 0.88rem;
  font-family: inherit;
  color: #1b2b3a;
  outline: none;
  cursor: pointer;

  &:focus { border-color: #26A9B6; }
  &:disabled { background: #f5f7f8; color: #a8b8c2; cursor: not-allowed; }
`;

export const LoadingMsg = styled.p`
  color: #999;
  font-size: 0.9rem;
  text-align: center;
  padding: 32px 0;
`;
